var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"w-2/4 bg-blue-600 text-white rounded",on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v(" "+_vm._s(_vm.$t('text.apply'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }